module.exports = __webpack_public_path__ + "static/media/arrow-right~FQkfMDmG.4e74ad62.svg";